export default __webpack_public_path__ + "static/media/ProximaNova-Light.a3c734ae.woff";